import * as d3 from 'd3'
export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.chart     = json.chart
      this.schedule  = json.schedule
      this.sundries  = json.sundries


      this.axis = d3.scaleLinear()
      .domain([0, 100])
      .range([0, this.chart.height])

    },
    
      
  }
}